import React from 'react';
import { CommentContent } from './Comment';
import { BodyText } from 'ui-toolkit';
import { useSelector } from 'react-redux';
import { VendorSelectors } from '../../../selectors/vendorPortal/VendorSelectors';
import { UUID } from '../../../types/shared/UUID';
import { eVendorServiceType, vendorServiceTypeCommentType } from '../../../types/order/title/eVendorServiceType';
import { uploadNewVendorComment } from '../../../store/vendorStore/vendorComments/dispatch';
import { ScrollContainerWrapper } from './ScrollContainerWrapper';
import { useAppDispatch } from '../../../store/store';

interface ICommentsProps {
  orderId: UUID;
  vendorServiceType: eVendorServiceType;
}

export const Comments: React.FC<ICommentsProps> = ({ orderId, vendorServiceType }) => {
  const dispatch = useAppDispatch();
  const onSubmit = (comment: string) => {
    dispatch(uploadNewVendorComment(orderId, comment, vendorServiceTypeCommentType[vendorServiceType]));
  };

  const { comments } = useSelector(VendorSelectors.selectComments);
  const orderComments = comments[orderId] ?? [];

  if (orderComments.length === 0) {
    return (
      <ScrollContainerWrapper onSubmit={onSubmit}>
        <BodyText>No comments yet</BodyText>
      </ScrollContainerWrapper>
    );
  }

  return (
    <ScrollContainerWrapper onSubmit={onSubmit}>
      {orderComments.map((comment) => (
        <CommentContent comment={comment} key={comment.id} />
      ))}
    </ScrollContainerWrapper>
  );
};
